import React, {Component} from 'react'
import CheckBoxItem from './CheckBoxItem'
import CheckBoxItemOther from './CheckBoxItemOther'

export default class CheckBox extends Component {
    constructor (props) {
        super(props)
        this.state = {
            activeItem: null
        };
    }

    componentDidMount = () => {
      
      if(this.props.prepop.hasOwnProperty('id')) {
        this.props.prepop.answers.forEach((item) => {
          this.onItemActive(true, item)
        })
      }

    }

    onItemActive = (active, item) => {
        this.setState({activeItem: item})
        
        if (item.other) {
            //debugger
            var newData = {
                "questionNumber": this.props.questionNumber,
                "valid": true,
                "id": this.getFirstQuestion().id,
                "answers": [{
                    "id": item.id,
                    "freeText": item.otherValue
                }]
            };
            //debugger
            this.props.manageFormData(newData)
        } else {
            var newData = {
                "questionNumber": this.props.questionNumber,
                "valid": true,
                "id": this.getFirstQuestion().id,
                "answers": [{
                    "id": item.id,
                    "freeText": item.text
                }]
            };
            this.props.manageFormData(newData)
        }

    }

  getFirstQuestion = () => this.props.data.questions[0]

    render() {
        const output = this.getFirstQuestion().answerOptions
          .sort((a, b) => a.orderDisplay - b.orderDisplay)
          .map((x, i) => {
            if (x.freeTextAllowed === '1') {
                return (
                    <CheckBoxItemOther
                      key={i}
                      id={i}
                      data={x}
                      questionNumber={this.props.questionNumber}
                      onToggle={this.onItemActive}
                      active={this.state.activeItem !== null && x.id === this.state.activeItem.id}
                    />
                )
            }
            return (
                <CheckBoxItem
                  key={i}
                  id={i}
                  data={x}
                  questionNumber={this.props.questionNumber}
                  onToggle={this.onItemActive}
                  active={this.state.activeItem !== null && x.id === this.state.activeItem.id}
                />
            )
        })
    return (
        <div>
            <h3 className='question-title'>{this.getFirstQuestion().text}</h3>
            <div className='custom-checkbox-wrapper'>
                <ul>
                    {output}
                </ul>
            </div>
        </div>
    )
  }
}
